export const API_BASE_URL = "https://dappvault-backend.herokuapp.com";
// export const API_BASE_URL = "http://localhost:3000";
export const STRING_NONCE = "msg";
export const PACKED_NONCE = "05013132366437333637";
